import { BaseError } from "./BaseError";

export class NotImplementedError extends BaseError {
  readonly status = 501;
}
